import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoints } from '@styles/index';
import Container, { Caption, Title, Description, StyledButton } from './styles';
import Benifits from './Benifits';

const StyledContainer = styled(Container)`
  @media (max-width: ${breakpoints.tablet}) {
    place-items: baseline;
  }
`;

const BackgroundColor = styled.div`
  background: #fcfcfc;
  padding-top: 120px;
  padding-bottom: 120px;
  @media (max-width: ${breakpoints.tablet}) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    padding: 80px 16px 40px;
  }
`;

const Cover = styled.section`
  grid-column: 7/19;
  text-align: center;
  margin-bottom: 36px;
  @media (max-width: ${breakpoints.tablet}) {
    grid-column: span 24;
    text-align: left;
    margin-bottom: 0;
  }
  @media (max-width: ${breakpoints.mobile}) {
    text-align: left;
  }
`;

const HighLightText = styled.span`
  color: orange;
`;

function Analyse({ data, scrollToForm, benifitsTitle }) {
  const { caption, title, subTitle, description, resource, buttonText } = data;
  return (
    <BackgroundColor>
      <StyledContainer>
        <Cover>
          <Caption>{caption}</Caption>
          <Title>
            <HighLightText>{`${title} `}</HighLightText>
            {subTitle}
          </Title>
          <Description>{description}</Description>
          <StyledButton onClick={scrollToForm} $hideSm $hideLg>
            {buttonText}
          </StyledButton>
        </Cover>
      </StyledContainer>
      <Benifits benifits={resource} benifitsTitle={benifitsTitle} />
    </BackgroundColor>
  );
}

Analyse.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  scrollToForm: PropTypes.func.isRequired,
  benifitsTitle: PropTypes.string
};

Analyse.defaultProps = {
  benifitsTitle: ''
};

export default Analyse;
